"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _context = require("../../context");

var _utils = require("../../utils");

var _ = require("../");

var _constants = require("../constants");

var _utils2 = require("../utils");

var Ring = (0, _context.styledWithTheme)('div')(function (_ref) {
  var selectors = _ref.theme.selectors,
      colorScheme = _ref.colorScheme,
      disabled = _ref.disabled,
      error = _ref.error;
  var isInverted = colorScheme === _.RadioColorScheme.Inverted;

  var getColor = function getColor(color) {
    return color === 'transparent' ? color : selectors.color(color);
  };

  var getColorParams = {
    disabled: disabled,
    error: error,
    getColor: getColor,
    isInverted: isInverted
  };
  var borderColor = (0, _utils2.getBorderColor)(getColorParams);
  return {
    minWidth: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    height: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    boxSizing: 'border-box',
    borderRadius: '1000px',
    border: "".concat((0, _utils.px)(_constants.DEFAULT_RING_SIZE), " solid ").concat(borderColor),
    transition: 'all 0.2s',
    position: 'relative'
  };
});
var _default = Ring;
exports.default = _default;